(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-photo-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-photo-gallery')) {
    customElements.define(
      'customer-photo-gallery',
      class CustomerPhotoGallery extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('.customer-gallery__viewport');
          this.track = this.querySelector('.customer-gallery__track');
          this.originalGroup = this.querySelector('.customer-gallery__group');

          if (!this.viewport || !this.track || !this.originalGroup || !this.originalGroup.children.length) return;

          this.rebuild = this.rebuild.bind(this);
          this.resizeObserver = new ResizeObserver(this.rebuild);
          this.resizeObserver.observe(this.viewport);
          this.rebuild();

          this.lightbox = this.querySelector('.customer-gallery__lightbox');
          if (this.lightbox) this.initLightbox();
        }

        disconnectedCallback() {
          if (this.resizeObserver) this.resizeObserver.disconnect();
        }

        initLightbox() {
          this.lightboxImage = this.lightbox.querySelector('.customer-gallery__lightbox-image');

          this.addEventListener('click', (event) => {
            const trigger = event.target.closest('[data-lightbox-trigger]');
            if (trigger) {
              this.openLightbox(trigger);
              return;
            }
            if (event.target === this.lightbox || event.target.closest('.customer-gallery__lightbox-close')) {
              this.closeLightbox();
            }
          });

          this.addEventListener('keydown', (event) => {
            const trigger = event.target.closest('[data-lightbox-trigger]');
            if (trigger && (event.key === 'Enter' || event.key === ' ')) {
              event.preventDefault();
              this.openLightbox(trigger);
              return;
            }
            if (event.key === 'Escape' && !this.lightbox.hidden) {
              this.closeLightbox();
            }
          });
        }

        openLightbox(trigger) {
          this.lastTrigger = trigger;
          this.lightboxImage.src = trigger.dataset.fullImage;
          this.lightboxImage.alt = trigger.dataset.fullAlt || '';
          this.lightbox.hidden = false;
          this.lightbox.querySelector('.customer-gallery__lightbox-close').focus();
        }

        closeLightbox() {
          this.lightbox.hidden = true;
          this.lightboxImage.removeAttribute('src');
          if (this.lastTrigger && this.lastTrigger.isConnected) this.lastTrigger.focus();
        }

        rebuild() {
          this.classList.remove('is-ready');
          this.track.querySelectorAll('[data-gallery-generated]').forEach((element) => element.remove());

          const originals = Array.from(this.originalGroup.children);
          const styles = getComputedStyle(this);
          const viewportStyles = getComputedStyle(this.viewport);
          const columns = Number.parseInt(styles.getPropertyValue('--gallery-columns'), 10) || 6;
          const gap = Number.parseFloat(styles.getPropertyValue('--gallery-gap')) || 0;
          const horizontalPadding =
            (Number.parseFloat(viewportStyles.paddingLeft) || 0) +
            (Number.parseFloat(viewportStyles.paddingRight) || 0);
          const contentWidth = this.viewport.clientWidth - horizontalPadding;
          const itemWidth = (contentWidth - gap * (columns - 1)) / columns;

          this.style.setProperty('--gallery-item-width', `${itemWidth}px`);

          while (this.originalGroup.scrollWidth < contentWidth + itemWidth) {
            originals.forEach((item) => {
              const clone = item.cloneNode(true);
              clone.setAttribute('data-gallery-generated', 'true');
              clone.removeAttribute('data-shopify-editor-block');
              clone.setAttribute('aria-hidden', 'true');
              this.originalGroup.appendChild(clone);
            });
          }

          const duplicateGroup = this.originalGroup.cloneNode(true);
          duplicateGroup.setAttribute('data-gallery-generated', 'true');
          duplicateGroup.setAttribute('aria-hidden', 'true');
          duplicateGroup.querySelectorAll('[data-shopify-editor-block]').forEach((item) => {
            item.removeAttribute('data-shopify-editor-block');
          });
          this.track.appendChild(duplicateGroup);

          this.style.setProperty('--gallery-loop-distance', `${this.originalGroup.scrollWidth}px`);
          requestAnimationFrame(() => this.classList.add('is-ready'));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      // Set announcement bar height after a short delay to ensure DOM is fully rendered
      setTimeout(() => {
        this.setAnnouncementBarHeight();
      }, 100);

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));
      
      // Update announcement bar height on window resize
      window.addEventListener('resize', () => {
        this.setAnnouncementBarHeight();
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      const searchToggle = this.querySelector('details-modal summary');
      if (searchToggle) {
        searchToggle.addEventListener('click', () => {
          setTimeout(() => {
            if (document.querySelector('details-modal details[open]')) {
              window.removeEventListener('scroll', this.onScrollHandler);

              const searchModal = document.querySelector('details-modal');
              const closeButton = searchModal.querySelector('button[type="button"]');

              const resumeScrollHandler = () => {
                window.addEventListener('scroll', this.onScrollHandler, false);
                closeButton.removeEventListener('click', resumeScrollHandler);
                document.body.removeEventListener('click', bodyClickHandler);
              };

              const bodyClickHandler = (event) => {
                if (!searchModal.contains(event.target) || event.target.classList.contains('modal-overlay')) {
                  resumeScrollHandler();
                }
              };

              closeButton.addEventListener('click', resumeScrollHandler);
              document.body.addEventListener('click', bodyClickHandler);
            }
          }, 10);
        });
      }

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section');
      if (announcementBar) {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const searchDetails = document.querySelector('details-modal details[open]');
      if (searchDetails) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.body.classList.contains('menu-flyout-open')) return;

      const searchDetails = document.querySelector('details-modal details[open]');
      if (searchDetails) return;

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal && !this.searchModal.querySelector('details[open]')) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medlemsdagar-flash-links"] && !Shopify.designMode) return;
  try {
    
  if (!window.mdFlashLinksInitialized) {
    window.mdFlashLinksInitialized = true;

    document.addEventListener('click', function(event) {
      const link = event.target.closest('[data-md-scroll-target]');
      if (!link) return;

      const targetId = link.getAttribute('data-md-scroll-target');
      const target = document.getElementById(targetId);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });

      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', '#' + targetId);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
